import { FormControlLabel, RadioGroup, styled } from '@mui/material';

export const FormControlLabelStyled = styled(FormControlLabel)(({ theme }) => ({
    borderRadius: '4px',
    background: theme.palette.background.default,
    border: `1px solid ${theme.palette.border.neutralPrimary}`,
    margin: 0,
    marginBottom: '10px',

    '&.selected': {
        border: `1px solid ${theme.palette.border.brandPrimary}`,
    },
    '&.Mui-disabled.selected': {
        border: `1px solid rgba(0, 0, 0, 0.15)`,
    },
}));

export const RadioGroupNPSStyled = styled(RadioGroup)(({ theme, isCardView = false}) => ({
    display: 'flex',
    flexDirection: 'row',
    borderRadius: '5px',
    border: '1px solid rgba(11, 11, 11, 0.10)',
    backgroundColor: '#FFF',
    width: 'fit-content',
    overflow: 'hidden',

    ...(isCardView
        ? {
              border: 'none',
              background: 'none',

              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
          }
        : {}),

    [theme.breakpoints.down('md')]: {
        border: 'none',
        background: 'none',

        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
    },
}));

export const FormControlLabeNPSlStyled = styled(FormControlLabel)(({ theme, isCardView = false }) =>{
    return {
        margin: 0,
        borderRight: '1px solid rgba(11, 11, 11, 0.10)',
        position: 'relative',

        '& .MuiButtonBase-root.MuiRadio-root': {
            borderRadius: 'unset',
            padding: isCardView ? '6px 8px' : '10px 14px',

            '& .MuiSvgIcon-root': {
                opacity: 0,
                visibility: 'hidden',
            },

            '&.Mui-checked': {
                background: '#0156FC',
                color: '#fff',
            },
        },
        '& .MuiFormControlLabel-label': {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
        },

        '& .MuiButtonBase-root.MuiRadio-root.Mui-checked + .MuiFormControlLabel-label': {
            color: '#fff',
        },

        ...(isCardView
            ? {
                  border: '1px solid rgba(11, 11, 11, 0.10)',
                  marginRight: '8px',
                  marginBottom: '8px',
              }
            : {}),

        [theme.breakpoints.down('md')]: {
            border: '1px solid rgba(11, 11, 11, 0.10)',
            marginRight: '8px',
            marginBottom: '8px',

            '& .MuiButtonBase-root.MuiRadio-root': {
                padding: '6px 8px',
            },
        },
    };
} );
